import { render, staticRenderFns } from "./TheAppDocumentGateway.vue?vue&type=template&id=0157ce42&"
import script from "./TheAppDocumentGateway.vue?vue&type=script&lang=js&"
export * from "./TheAppDocumentGateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports